import * as React from 'react';
import { Button, Space, Tooltip } from 'antd';
import { CopyOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons';

interface HolidayToolbarProps {
    onCopy: () => void;
    onSave: () => void;
    onBulkAdd: () => void;
    disableCopy?: boolean;
    disableSave?: boolean;
    disableBulkAdd?: boolean;
    saving?: boolean;
    copying?: boolean;
    hasChanges?: boolean;
    hasDuplicateHolidays?: boolean;
}

const HolidayToolbar: React.FC<HolidayToolbarProps> = ({
    onCopy,
    onSave,
    onBulkAdd,
    disableCopy = false,
    disableSave = false,
    disableBulkAdd = false,
    saving = false,
    copying = false,
    hasChanges = false,
    hasDuplicateHolidays = false,
}) => {
    const saveTooltip = React.useMemo(() => {
        if (hasDuplicateHolidays) {
            return 'Use a unique holiday name for each school before saving.';
        }
        if (hasChanges) {
            return 'Save all new or deleted holidays';
        }
        return 'No pending changes to save';
    }, [hasChanges, hasDuplicateHolidays]);

    return (
        <div className="holiday-toolbar">
            <Space wrap>
                <Tooltip title={disableCopy && hasChanges ? 'Save or remove all unsaved holidays before copying again.' : 'Copy holidays from the previous year for the selected schools'}>
                    <span>
                        <Button
                        icon={<CopyOutlined />}
                        onClick={onCopy}
                        disabled={disableCopy}
                        loading={copying}
                    >
                        Copy from Prev Year
                    </Button>
                    </span>
                </Tooltip>
                <Tooltip title={saveTooltip}>
                    <Button
                        type="primary"
                        icon={<SaveOutlined />}
                        onClick={onSave}
                        disabled={disableSave || !hasChanges}
                        loading={saving}
                    >
                        Save
                    </Button>
                </Tooltip>
                <Tooltip title="Add a new holiday row for the selected schools">
                    <Button
                        icon={<PlusOutlined />}
                        onClick={onBulkAdd}
                        disabled={disableBulkAdd}
                    >
                        Add
                    </Button>
                </Tooltip>
            </Space>
        </div>
    );
};

export default HolidayToolbar;